module.exports = __webpack_public_path__ + "static/media/flag-om.e04dadc0.webp";